import { useEffect, useState } from 'react';
import { type DialerTabStatus, NoOwnership, dialerTabCoordinator } from '../services/dialerTabCoordinator';

/**
 * Live cross-tab ownership of the Twilio Device, for the identity in `scope`.
 *
 * Shared by both softphones so they cannot drift: the legacy path once cached "blocked" in
 * its own state, which had no way back to `false` when the other tab hung up. Reading the
 * broadcast state instead means neither path can go stale.
 *
 * `subscribe` fires synchronously with the current status, so the initial value is a
 * placeholder — resolving the coordinator during render would build or retire one as a
 * side effect of rendering.
 */
export function useDialerTabStatus(scope: string): DialerTabStatus {
	const [status, setStatus] = useState<DialerTabStatus>(NoOwnership);

	useEffect(() => dialerTabCoordinator(scope).subscribe(setStatus), [scope]);

	return status;
}
